<div class="modal-content">
  <div class="modal-body text-center">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <jhi-bary-icon icon="times" [faDirective]="FAS" size="4x" class="text-danger"></jhi-bary-icon>
    <p class="lead mt-4">{{ title }}</p>
    <div class="text-left text-danger">
      <ul>
        <li *ngFor="let error of errors">{{ error }}</li>
      </ul>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button
      *ngIf="buttons.first"
      [block]="!buttons.second"
      [outline]="true"
      color="primary"
      [label]="buttons.first"
      (clickEvent)="handleClick({ first: true })"
    ></jhi-bary-button>
    <jhi-bary-button (clickEvent)="handleClick({ second: true })" *ngIf="buttons.second" [label]="buttons.second" color="primary"></jhi-bary-button>
  </div>
</div>
